import { useMutation } from "@tanstack/react-query";
import { campaignsService } from "@/services/campaignsService";

// mutations keys
export const campaignsMutationKeys = {
  all: ["campaigns"],
  list: () => [...campaignsMutationKeys.all, "list"],
  details: (id) => [...campaignsMutationKeys.all, "detail", id],
};      


// create campaign
export const useCreateCampaign = (options = {}) => {
  return useMutation({
    mutationFn: (campaignData) => campaignsService.createCampaign(campaignData),
    onError: (error) => {
      // Log the error for debugging
      console.error('Mutation error:', error);
      
      // Call the user-provided onError if it exists
      if (options.onError) {
        // Pass the error data directly
        options.onError(error);
      }
    },
    ...options
  });
};

// Add update campaign mutation
export const useUpdateCampaign = (options = {} ) => {
  return useMutation({
    mutationFn: ({ id, campaignData, shouldRedirect = true }) => campaignsService.updateCampaign(id, campaignData),
    onError: (error) => {
      console.error('Update mutation error:', error);
      if (options.onError) {
        options.onError(error);
      }
    },
    ...options
  });
};


